import { AfterViewInit, Directive, ElementRef, ViewChild } from '@angular/core';
import { OperatorFunction, switchMap } from 'rxjs';
import { SelectorOption } from 'src/app/interfaces/form-and-field.interface';
import { SearchParams } from 'src/app/interfaces/search.interface';
import { OrganizationLink } from '../../../swagger-api';
import { SuggestionFieldShared } from './suggestion-field.shared';

@Directive()
export abstract class SuggestionSearchFieldShared extends SuggestionFieldShared implements AfterViewInit {
  @ViewChild('multipleSearchInput', { static: false })
  public multipleSearchInput: ElementRef<HTMLInputElement>;

  public ngAfterViewInit(): void {
    if (this.multipleSearchInput) {
      this.multipleSearchInput.nativeElement.setAttribute(
        'size',
        this.fieldAttribute.backendAttribute.placeholder.length.toString(),
      );
    }
  }

  protected getOptionsOperatorFunction(): OperatorFunction<SearchParams, SelectorOption[]> {
    return switchMap((searchParams: SearchParams) =>
      this.optionsService.getUpdatedOptions(this.fieldAttribute, searchParams, this.getSelectedItems()),
    );
  }

  protected abstract getSelectedItems(): SelectorOption[] | OrganizationLink[];
}
